import Vue from 'vue'

export const canvas = {
  namespaced: true,
  state: {
    items: {},
    img: '/choice/img/common/no-img.png',
  },
  mutations: {
    itemsFirstSet(state, payload) {
      for (let i = 0; i < payload.length; i++) {
        Vue.set(state.items, payload[i].page.order, payload[i])
      }
    },
    itemsSet(state, payload) {
      if (payload.state) {
        Vue.set(state.items, payload.index, payload.item)
      } else {
        Vue.delete(state.items, payload.index)
      }
    },
    stagesReset(state, payload) {
      for (let key in state.items) {
        let num = Number(key.replace('-', '.'))
        if (num > 3) {
          Vue.delete(state.items, key)
        }
      }
    },
    itemsReset(state) {
      state.items = {}
      state.img = '/choice/img/common/no-img.png'
    },
    imgSet(state, payload) {
      state.img = payload
    },
  },
}
